module.exports = __webpack_public_path__ + "static/img/cp2-r4vjOU1w.6283986.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/cp2-r4vjOU1w.png
// module id = HTR4
// module chunks = 16